import { useState } from 'react';

export function usePageTransition() {
  const [destination, setDestination] = useState<string | null>(null);

  const triggerTransition = (to: string) => {
    setDestination(to);
  };

  const clearDestination = () => {
    setDestination(null);
  };

  return { destination, triggerTransition, clearDestination };
}
